import { Component, Input } from '@angular/core';
import { TreeNode } from '@openng/optimus-ui/api';
import { TreeModule } from '@openng/optimus-ui/tree';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-audit-log-tree-v2',
    templateUrl: 'audit-log-tree-v2.component.html',
    styleUrl: 'audit-log-tree-v2.component.scss',
    imports: [
    TreeModule,
    TranslatePipe,
    NgClass
],
})
export class AuditLogTreeV2Component {

    @Input() tree!: TreeNode[];
    @Input() action: string = 'read';

    protected readonly Array = Array;
}
